<div class="scroll-content">
  <div class="upsellDownsell upsell-page">
    <div class="upDownPage">
      @for (content of pageContents; track trackByIndex($index, content); let i = $index) {
        @switch (content.type) {
          @case ('component') {
            @if (content.componentName === 'brand-header') {
              <brand-header [content]="content.options" class="{{ content.class }}"></brand-header>
            } @else if (content.componentName === 'upsell-banner') {
              <upsell-banner [bannerText]="bannerText" [bannerImage]="bannerImage"
                class="{{ content.class }}"></upsell-banner>
            } @else if (content.componentName === 'upsell-buttons') {
              <upsell-buttons [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText"
                (eventEmitter)="nextPage($event)" class="{{ content.class }}"></upsell-buttons>
            } @else if (content.componentName === 'upsell-sticky-bar') {
              <upsell-sticky-bar [ngClass]="content.class" (eventEmitter)="nextPage($event)"
                [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText"
                [displayAfterMobile]="content.options?.displayAfterMobile">
              </upsell-sticky-bar>
            } @else if (content.componentName === 'upsell-mbg') {
              <upsell-mbg [mbgCTA]="mbgCTA" [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText"
                [productName]="productName" [mbgText]="mbgText" class="{{ content.class }}"
                (eventEmitter)="nextPage($event)"></upsell-mbg>
            } @else if (content.componentName === 'upsell-wait') {
              <upsell-wait [title]="waitTitle" [description]="waitDescription" [iconWait]="waitIcon" class="{{ content.class }}"></upsell-wait>
            } @else if (content.componentName === 'vidalytics-video') {
              <video-player-vidalytics
                [vidalyticsEmbedId]="vidalyticsEmbedId"
                [vidalyticsEmbedIdMobile]="vidalyticsEmbedIdMobile"
                class="{{ content.class }}">
              </video-player-vidalytics>
            } @else if (content.componentName === 'upsell-section') {
              <upsell-section [ngClass]="content.class" [content]="content.options"></upsell-section>
            } @else if (content.componentName === 'upsell-why') {
              <upsell-why class="{{ content.class }}" [upsellWhyContent]="content.options"
                [upsellWhyImage]="upsellWhyImage"></upsell-why>
            } @else if (content.componentName === 'upsell-faq') {
              <upsell-faq class="{{ content.class }}" [upsellFaqContent]="content.options"></upsell-faq>
            } @else if (content.componentName === 'upsell-product-box') {
              <upsell-product-box [currency]="currency"
                [productBoxTitle]="productBoxTitle" [image]="productImage" [imageAlt]="productTitle"
                [productBoxSubtitle]="productBoxSubtitle" [regularPrice]="productRegularPrice"
                [instantSavings]="productInstantSavings" [yourPriceText]="product_box_yourPriceText"
                [instantSavingsText]="product_box_instantSavingsText" [regularText]="product_box_regularText"
                [yourPrice]="productYourPrice"
                [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [productBoxCTA]="productBoxCTA"
                (eventEmitter)="nextPage($event)" class="{{ content.class }}">
              </upsell-product-box>
            } @else if (content.componentName === 'upsell-multi-selector') {
              @if (displayedProducts && displayedProducts.length > 0) {
                <upsell-multi-selector (pickedProduct)="changeUpsell($event)" [productOptions]="this.displayedProducts[0].productOptions"
                  [currency]="currency" class="{{ content.class }}">
                </upsell-multi-selector>
              }
            } @else if (content.componentName === 'upsell-guarantee') {
              <upsell-guarantee [buttonYesText]="buttonYesText" [buttonNoText]="buttonNoText" [guaranteeCopy]="guaranteeCopy" [guaranteeImage]="guaranteeImage"
                (eventEmitter)="nextPage($event)"
                class="{{ content.class }}"></upsell-guarantee>
            } @else if (content.componentName === 'upsell-modal') {
              <upsell-modal [upsellModalInputs]="content.options || {}"></upsell-modal>
            } @else if (content.componentName === 'upsell-slider') {
              <upsell-slider [peopleSayList]="content.options?.peopleSayList || []"
                (slideChangeEvent)="onSliderChange($event, content)"
                (goPreviousEvent)="onSliderPrevious($event, content)" (goNextEvent)="onSliderNext($event, content)"
                class="{{ content.class }}">
              </upsell-slider>
            } @else if (content.componentName === 'brand-footer') {
              <brand-footer class="{{ content.class }}"></brand-footer>
            }
          }
          @case ('html') {
            <div class="{{ content.name }} {{ content.class }}" [innerHTML]="content.html">
            </div>
          }
        }
      }
    </div>
  </div>
</div>
